import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../services/user-service';
import { AccountComponent } from '../../account/account.component';

@Component({
  selector: 'app-settings-layout',
  templateUrl: './settings-layout.component.html',
  styleUrls: ['./settings-layout.component.scss'],
  standalone: false
})
export class SettingsLayoutComponent implements OnInit {
  settingsTitle: string = 'Settings';

  constructor(
    private userService: UserService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    // Intentionally empty - settingsTitle is static 'Settings' for now, as breadcrumb logic is in AppComponent.
    // If dynamic title from breadcrumbs is required here, we would need to subscribe to router events or a shared service.
  }

  /**
   * Checks if subscription information should be displayed for the current user.
   * @returns True if user is a subscribed user, false otherwise.
   */
  canShowSubscription(): boolean {
    return this.userService.isSubscribedUser();
  }

  /**
   * Opens the user profile modal dialog.
   * Updates the profile picture observable when the modal is closed successfully.
   */
  openProfileModal() {
    this.modalService.open(AccountComponent).result
      .then(() => {
        this.userService.changeProfilePicObs();
      })
      .catch();
  }
}

